import { useMemo } from 'react';

import { buildInventorySearchValues } from 'components/warehouse/components/locationInventoryV2Components/inventorySearchValues';

/**
 * Memoized searchValues for location inventory tabs and expansion panels.
 *
 * @param {{ searchBy?: string, searchTerm?: string | number, type?: string }} queryParams
 * @returns {Array<{ searchBy: string, searchTerm: string | number }>}
 */
export function useInventorySearchValues(queryParams = {}) {
    const { searchBy, searchTerm, type } = queryParams;

    return useMemo(() => buildInventorySearchValues({ searchBy, searchTerm, type }), [searchBy, searchTerm, type]);
}
